import Constants from '@/constants';

export default {
  /**
   * Creates a new haus evaluation
   * @param {*} data - the data used for the evaluation
   * @returns {Promise} - A promise containing the response data
   */
  createHausEvaluation(data) {
    if (!data.kundeVorname) {
      data.kundeVorname = 'Nicht angegeben';
    }
    if (!data.kundeNachname) {
      data.kundeNachname = 'Nicht angegeben';
    }

    return fetch(`${Constants.API_BASE_URL}/CreateShortSignedHouseEvaluation`, {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/vnd.at.spardat.ibw.ibwinternetservices.representation.short.house.input+json',
        AppCode: 'ZEB',
        'Egh-Application': 'web',
      },
      body: JSON.stringify(data),
    });
  },

  /**
   * Creates a new wohnung evaluation
   * @param {*} data - the data used for the evaluation
   * @returns {Promise} - A promise containing the response data
   */
  createWohnungEvaluation(data) {
    if (!data.kundeVorname) {
      data.kundeVorname = 'Nicht angegeben';
    }
    if (!data.kundeNachname) {
      data.kundeNachname = 'Nicht angegeben';
    }

    return fetch(
      `${Constants.API_BASE_URL}/CreateShortSignedApartmentEvaluation`,
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/vnd.at.spardat.ibw.ibwinternetservices.representation.short.apartment.input+json',
          AppCode: 'ZEB',
          'Egh-Application': 'web',
        },
        body: JSON.stringify(data),
      },
    );
  },

  /**
   * Creates a new dg-wohnung evaluation
   * @param {*} data - the data used for the evaluation
   * @returns {Promise} - A promise containing the response data
   */
  createDgWohnungEvaluation(data) {
    if (!data.kundeVorname) {
      data.kundeVorname = 'Nicht angegeben';
    }
    if (!data.kundeNachname) {
      data.kundeNachname = 'Nicht angegeben';
    }

    return fetch(
      `${Constants.API_BASE_URL}/CreateShortSignedApartmentEvaluation`,
      {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/vnd.at.spardat.ibw.ibwinternetservices.representation.short.apartment.input+json',
          AppCode: 'ZEB',
          'Egh-Application': 'web',
        },
        body: JSON.stringify(data),
      },
    );
  },

  /**
   * Sends a subscription request for the newsletter
   * @returns {Promise} - A promise containing the response data
   */
  subscribeToNewsletter() {
    const f_zweck = sessionStorage.getItem(Constants.PREFIX + '.f_zweck');
    let idNewsletter = '';
    if (process.env.VUE_APP_MANDANT == 'sbau') {
      idNewsletter = Constants.ID_NL_SBAU;
    } else {
      idNewsletter =
        f_zweck === 'KAUF'
          ? Constants.ID_THEMA_KAUFEN
          : Constants.ID_THEMA_VERKAUFEN;
    }

    return fetch(Constants.NEWSLETTER_URL, {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/vnd.at.spardat.prospects.outbound.registercustomer.representation.register.basic.input+json',
      },
      body: JSON.stringify({
        email: sessionStorage.getItem(Constants.PREFIX + '.kundeEmail'),
        hasMarketingAllowed: '',
        hasThemaMarketingAllowed: '',
        idThema: idNewsletter,
        portalMandant: 9,
        firstName: sessionStorage.getItem(Constants.PREFIX + '.kundeVorname'),
        lastName: sessionStorage.getItem(Constants.PREFIX + '.kundeNachname'),
        salutation: sessionStorage.getItem(Constants.PREFIX + '.kundeAnrede'),
      }),
    });
  },

  /**
   * Gets the available cities for a given zip code
   */
  getPlacesForZipCode(zipCode) {
    return fetch(`${Constants.API_BASE_URL}/PlacesForZipCode`, {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/vnd.at.spardat.ibw.ibwallnetservices.representation.zip.code.details.input+json',
        AppCode: 'ZEB',
      },
      body: JSON.stringify({
        countryIso: 'AT',
        zipCode: zipCode,
      }),
    });
  },

  /**
   * Gets the available streets for a given zip code, city and street substring
   */
  getStreetSuggestions(zipCode, city, street, houseNumber) {
    return fetch(`${Constants.API_BASE_URL}/StreetSuggestion`, {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/vnd.at.spardat.ibw.ibwinternetservices.representation.street.suggestion.input+json',
        AppCode: 'ZEB',
      },
      body: JSON.stringify({
        zipCode: zipCode,
        city: city,
        street: street,
        houseNumber: houseNumber,
      }),
    });
  },
};
